import PropTypes from "prop-types";
import React from "react";
import { Typography, Box } from "@mui/material";

const Breadcrumb = ({ routes }) => {
  const displayedRoutes = routes.filter(route => !!route);
  return (
    <Box display="flex" flexWrap="wrap">
      {displayedRoutes.map((route, index) => (
        <Typography
          key={route + index}
          variant="h5"
          color={
            index === displayedRoutes.length - 1
              ? "textPrimary"
              : "textSecondary"
          }
        >
          {`${route || ""} ${index !== displayedRoutes.length - 1 ? " /" : ""}`}
          &nbsp;
        </Typography>
      ))}
    </Box>
  );
};

Breadcrumb.propTypes = {
  routes: PropTypes.arrayOf(PropTypes.string)
};

export default Breadcrumb;
